//@flow
import React, {useState} from 'react';
import {makeStyles} from '@material-ui/core';
import {colors} from '../../../../assets/styles/colors';
import {Check} from '@material-ui/icons';
import {useEffect} from 'react';

const useStyles = makeStyles(theme => ({
  container: {
    display: 'flex',
    alignItems: 'center',
    gap: '.75rem',
    padding: '.5rem',
    cursor: 'pointer',

    '&[data-disabled="true"]': {
      pointerEvents: 'none',
      opacity: 0.4,
    },

    '&[data-pinter-none="true"]': {
      pointerEvents: 'none',
    },
  },
  customCheckbox: {
    width: '20px',
    height: '20px',
    borderRadius: '50%',
    border: `1.5px solid ${colors.grey400}`,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',

    '& svg': {
      fontSize: '14px',
    },

    '&[data-checked="true"]': {
      border: `1.5px solid #3E7BFA`,
      background: '#3E7BFA',
      color: 'white',
    },
  },
  label: {
    fontWeight: 500,
    color: colors.grey900,
    opacity: 0.4,

    '&[data-checked="true"]': {
      opacity: 1,
    },
  },
}));

type Props = {
  checked?: boolean,
  onChange?: (checked: boolean) => void,
  disabled?: boolean,
  pointerNone?: boolean,
  controlled?: boolean,
};
export default function ActiveCheckBox(props: Props) {
  const {disabled, pointerNone} = props;

  const [checked, setChecked] = useState(props.checked);

  const classes = useStyles();

  const label = checked ? 'Activado' : 'Desactivado';

  useEffect(() => {
    setChecked(props.checked);
  }, [props.checked]);

  const handleChange = () => {
    if (!props.controlled) setChecked(!checked);
    if (props.onChange) props.onChange(!checked);
  };

  return (
    <label
      className={classes.container}
      data-disabled={disabled}
      data-pinter-none={pointerNone}
    >
      <input type="checkbox" checked={checked} onChange={handleChange} hidden />
      <span className={classes.customCheckbox} data-checked={checked}>
        {checked && <Check />}
      </span>
      <span className={classes.label} data-checked={checked}>
        {label}
      </span>
    </label>
  );
}
